// Vendor imports
const React = require('react')
const { useSelector } = require('react-redux')
// Shared imports
const {
  CanceledPromiseError,
  makePromiseCancelable
} = require('shared/promise-utils')
// Client lib imports
const airbrake = require('client/lib/airbrake')
// Sibling imports
const { fetchSvg } = require('./utils')

function IconsLoader() {
  const url = useSelector(state => state.env.iconsUrl)
  React.useEffect(
    () => {
      // Do nothing during server-side rendering
      if (typeof document === 'undefined') {
        return
      }
      let svgEl
      const parentEl = document.body
      const fetchPromise = fetchSvg(url)
      const promiseWrapper = makePromiseCancelable(fetchPromise)
      promiseWrapper.promise
      .then(result => {
        svgEl = result
        parentEl.insertBefore(svgEl, parentEl.firstChild)
      })
      .catch(err => {
        if (!(err instanceof CanceledPromiseError)) {
          airbrake.notify(err)
        }
      })
      return () => {
        if (svgEl) {
          parentEl.removeChild(svgEl)
        } else {
          promiseWrapper.cancel()
        }
      }
    },
    [ url ]
  )
  return null
}

module.exports = IconsLoader
